// Side-effect-only module whose sole job is to arm error reporting before anything else
// in the bundle runs.
//
// It exists as a separate file because ES module imports are evaluated in order, and the
// other modules in the entry point do real work at import time (tinode-web.jsx
// constructs an Audio object, the Tinode SDK builds an Intl.Segmenter). Importing this
// file first in src/index.js means an exception thrown while those modules initialize is
// still captured -- which is exactly the class of bug that is otherwise invisible,
// because the app just renders a blank page.

import { initErrorReporting, throwTestError } from './lib/error-reporting.js';

initErrorReporting();

// Manual trigger, so error capture can be proven against any deployment from the
// browser console: __apporiginThrowTestError('smoke').
//
// Also reachable as #?debug=throw-test-error. This is a URL the user has to type; it
// only throws, and carries no data. It is left in the production build on purpose: being
// able to verify that a *deployed* build reports correctly is worth more than hiding a
// deliberate crash that a user has to opt into.
if (typeof window != 'undefined') {
  window.__apporiginThrowTestError = throwTestError;
  if (String(window.location.hash || '').indexOf('debug=throw-test-error') >= 0) {
    throwTestError('hash');
  }
}
